import React, { useEffect, useState } from 'react';

import { useGetSample } from '@vlabs/api/artemy/client';
import type { Uuid } from '@vlabs/api/artemy/model/Uuid';
import { ZoomInIcon, DownloadIcon } from '@vlabs/icons';
import type { BodySampleProps } from '@vlabs/uikit';
import { BodySample, ButtonScrimGroup } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';

import { useFullscreenImageViewer } from '@vlabs/monokit/features/view-photo';
import { downloadImage } from '@vlabs/monokit/shared/lib/images';

import { buildTestid } from '../../../../shared/lib/utils';

interface EventBodyDetectionSamplePoint3Props extends Omit<BodySampleProps, 'src' | 'buttonOnBottom'> {
  sampleId: Uuid;
}

const displayName = 'EventBodyDetectionSamplePoint3';
const testid = buildTestid(displayName);

function EventBodyDetectionSamplePoint3({
  sampleId,
  'data-testid': dataTestId = undefined,
  ...props
}: EventBodyDetectionSamplePoint3Props): React.JSX.Element {
  const { data: sample } = useGetSample('bodies', sampleId, {
    query: { enabled: !!sampleId },
  });
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    if (!sample) {
      setSrc(undefined);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(sample);
    setSrc(objectUrl);

    return () => URL.revokeObjectURL(objectUrl);
  }, [sample]);

  const fullscreenImageViewer = useFullscreenImageViewer({ url: src });

  return (
    <BodySample
      buttonOnBottom={(
        <ButtonScrimGroup size="small">
          {/* //FIXME: Заменить на ViewPhotoIconButton и DownloadImageIconButton когда ButtonScrimGroup будет поддерживать */}
          <IconButton
            disabled={!src}
            icon={<ZoomInIcon />}
            kind="secondary"
            onClick={fullscreenImageViewer}
            size="small"
            variant="flat"
            {...testid('ZoomButton', dataTestId)}
          />
          <IconButton
            disabled={!src}
            icon={<DownloadIcon />}
            kind="secondary"
            onClick={() => downloadImage(src)}
            size="small"
            variant="flat"
            {...testid('DownloadButton', dataTestId)}
          />
        </ButtonScrimGroup>
      )}
      size="large"
      src={src}
      {...testid(dataTestId)}
      {...props}
    />
  );
}

EventBodyDetectionSamplePoint3.displayName = displayName;

export { EventBodyDetectionSamplePoint3 };
